import { axiosInstance } from '@/redux/api/api-configuration'
import { ProductRecommenderApi } from '@itsrever/rever-api'

export const productRecommenderApi = new ProductRecommenderApi(
  undefined,
  undefined,
  axiosInstance
)
